
    import { Component, Vue } from "vue-property-decorator";
    import moment from "moment";
    import { namespace } from "vuex-class";

    const profile = namespace("profile");

    @Component({})
    export default class EmploymentDetails extends Vue {
        @profile.State
        public profileData!: any;

        mounted() {
            localStorage.setItem("guarenteedHours", this.profileData.guarenteedHours);
            localStorage.setItem("UserName", this.profileData.first + " " + this.profileData.last);
        }

        // computed

        get getName() {
            return (this.profileData.first + " " + this.profileData.last);
        }
        get getFullHomeAddress() {
            let fulladdress = "";
            fulladdress =
                this.profileData.address1 != "" ? this.profileData.address1 + "," : "";
            fulladdress =
                this.profileData.address2 != ""
                    ? fulladdress != ""
                        ? fulladdress + " " + this.profileData.address2 + ","
                        : this.profileData.address2 + ","
                    : fulladdress;
            fulladdress =
                this.profileData.city != ""
                    ? fulladdress != ""
                        ? fulladdress + " " + this.profileData.city
                        : this.profileData.city
                    : fulladdress;
            fulladdress =
                this.profileData.state != ""
                    ? fulladdress != ""
                        ? fulladdress + " " + this.profileData.state
                        : this.profileData.state
                    : fulladdress;
            fulladdress =
                this.profileData.zip != ""
                    ? fulladdress != ""
                        ? fulladdress + " " + this.profileData.zip
                        : this.profileData.zip
                    : fulladdress;
            return fulladdress;
        }
        
        get getPrimarySkill() {
            let primarySkill = "";
            if (typeof this.profileData.skills !== "undefined") {
                for (var i = 0; i < this.profileData.skills.length; i++) {
                    if (this.profileData.skills[i].primary === true) {
                        primarySkill = this.profileData.skills[i].description;
                        break;
                    }
                }
            }
            return primarySkill;
        }

        get getHireDate() {
            return this.profileData.hired != null
                ? moment(String(this.profileData.hired)).format("MM/DD/YYYY")
                : "";
        }
        get getFacility() {
            return "(" + this.profileData.coid + ") " + this.profileData.facilityName;
        }
        get getDept() {
            return "(" + this.profileData.deptCode + ") " + this.profileData.deptName;
        }
    }
